export const SystemDataSequenceEntityTypes = [
  "WINDOW",
  "DOOR",
  "ELECTRICAL",
  "PROP",
  "CASEWORK",
  "SLAB",
  "FOOTING",
  "FRAMING",
  "FLOORING",
  "FLOOR_MATERIALS_SUMMARY",
  "INTERIOR_FINISH",
  "ROOF",
  "ROOF_AREA",
  "ROOF_ANALYTIC_AREA",
  "ROOF_ANALYTIC_LENGTH",
  "ROOF_RIDGE",
  "ROOF_RIDGE_VENT",
  "ROOF_VALLEY",
  "ROOF_EAVE",
  "ROOF_FLASHING",
  "WALL",
  "WALL_AREA",
  "CEILING",
  "BUILDING_AREA",
  "BUILDING_OPTION",
  "BUILDING_PRESET",
  "MILLWORK",
  "EXTERIOR_TRIM",
  "EXTERIOR_FINISH",
  "OPENING_TRIM",
  "OPENING_CASING",
] as const;

export type SystemDataSequenceEntityType = (typeof SystemDataSequenceEntityTypes)[number];

export const SHEETS_DATA_SEQUENCE_ID = "SHEETS";

export const SystemDataSequenceIds = [...SystemDataSequenceEntityTypes, SHEETS_DATA_SEQUENCE_ID] as const;

export type SystemDataSequenceId = (typeof SystemDataSequenceIds)[number];
